import React, { Component } from "react";
import { Div, Text, Image } from "atomize";

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

export default class InfluencerChart extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div className="influencer-chart solutions">
            <Div
              textAlign={{ xs: "left", md: "center" }}
              m="0 auto  2.8rem"
              maxW="49.375rem"
            >
              <Text
                textSize="title2"
                textWeight="bold"
                tag="h2"
                m={{ b: ".8rem" }}
              >
                {content.heading}
              </Text>
              <Text
                textSize={{ xs: "15px", md: "paragraph" }}
                className="sub-text"
                textColor="#D9D9D9"
              >
                {content.text}
              </Text>
            </Div>
            <Div>
              <Div
                border="1px solid"
                w="fit-content"
                borderColor="white"
                textAlign="center"
                m="0 auto"
                p={{ x: ".5rem", t: ".5rem" }}
              >
                <ImageLink link={content.imgLink}>
                  <Image
                    h={{ xs: "19.256rem", md: "23.75rem" }}
                    alt={content.alt && content.alt}
                    w="auto"
                    src={content.img}
                  />
                </ImageLink>
              </Div>
              <Div d={{ xs: "block", md: "none" }}>
                {content.chartContent.map((data, id) => {
                  return (
                    <Div key={id} m={{ t: "3.5rem" }}>
                      <ImageLink link={data.iconLink}>
                        <Image
                          src={data.icon}
                          alt={data.alt && data.alt}
                          h="auto"
                          w="25px"
                          m={{ b: ".4rem" }}
                        />
                      </ImageLink>
                      <Text textSize="paragraph" tag="h3" textWeight="bold">
                        {data.heading}
                      </Text>
                      <Text
                        textSize="15px"
                        className="sub-text"
                        textColor="#d9d9d9"
                      >
                        {data.info}
                      </Text>
                    </Div>
                  );
                })}
              </Div>
              <Div d={{ xs: "none", md: "block" }}>
                <Div
                  h="3rem"
                  w="1px"
                  m="0 auto"
                  className="border-gradient"
                ></Div>
              </Div>
            </Div>
            <Div
              d={{ xs: "none", md: "block" }}
              style={{ borderTop: "2px solid #979797" }}
            >
              <Div d="flex" justify="space-around">
                {content.chartContent.map((data, id) => {
                  const even = id % 2 == 0;
                  return (
                    <Div w="230px" key={id} m="0 -25px">
                      <Div m="0 auto">
                        <Div
                          pos="relative"
                          h={even === true ? "3.57rem" : "16.94rem"}
                        >
                          <Div
                            className="dropdown-gradient"
                            m="0 auto"
                            h={even === true ? "30px" : "13.2rem"}
                            w="1rem"
                          ></Div>
                          <Div
                            pos="absolute"
                            top="0"
                            left="50%"
                            transform="translateX(-50%)"
                          >
                            <Div
                              h={even === true ? "3.57rem" : "16.94rem"}
                              m="0 auto"
                              w="1px"
                              className="border-gradient"
                              //style={{ border: ".3px solid #d8d8d8" }}
                            ></Div>
                            <Div
                              bg="#fff"
                              pos="absolute"
                              bottom="0"
                              left="50%"
                              transform="translateX(-50%)"
                              h="5px"
                              w="5px"
                              rounded="circle"
                            ></Div>
                          </Div>
                        </Div>
                      </Div>
                      <Div m={{ t: "1.7rem" }} textAlign="center">
                        <ImageLink link={data.iconLink}>
                          <Image
                            src={data.icon}
                            h="auto"
                            w="25px"
                            m={{ b: ".8rem" }}
                          />
                        </ImageLink>
                        <Text textWeight="bold" tag="h3">
                          {data.heading}
                        </Text>
                        <Text textColor="#d9d9d9">{data.info}</Text>
                      </Div>
                    </Div>
                  );
                })}
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
